<template>
  <div class="content mirroring">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <div class="describe">
        {{$t('mirroring.describe')}}
      </div>
      <div class="formRow">
        <span class="title">{{$t('mirroring.enable')}}:</span>
        <toggle :on="isMirroringEnable" @click.native="onSwitchBtn()"></toggle>
      </div>
      <div class="formRow mode">
        <div class="title">{{$t('mirroring.type')}}</div>
        <radio :label="$t('mirroring.transReceive')" :checked="isItemChecked(typeRadioItems[0])" @click.native="onSelection(typeRadioItems[0])" :disabled="isDisabled"></radio>
        <radio :label="$t('mirroring.transOnly')" :checked="isItemChecked(typeRadioItems[1])" @click.native="onSelection(typeRadioItems[1])" :disabled="isDisabled"></radio>
        <radio :label="$t('mirroring.receiveOnly')" :checked="isItemChecked(typeRadioItems[2])" @click.native="onSelection(typeRadioItems[2])" :disabled="isDisabled"></radio>
      </div>
      <table class="group-table" v-if="isMirroringEnable">
        <tr class="table-header">
          <td class="title" style="width:20%;">
            <!-- <div class="slash" :data-text="$t('item')"></div> -->
            <div class="subtitle">{{$t('port.portnumber')}}</div>
          </td>
          <td class="item" style="width:5%;" v-for="num in portNumber" :key="num">{{num}}</td>
        </tr>
        <tr class="table-item">
          <td class="title" style="width:20%;">{{$t('mirroring.sourceNoColon')}}</td>
          <td class="item" style="width:5%;" v-for="num in portNumber" :key="num">
            <div class="formlabel fontB subitem" v-on:click="ontableSelection(num)">
              <checkbox class="q-checkbox-label" :checked="istableItemChecked(num)" :disabled="getDisable(num)"/>
            </div>
          </td>
        </tr>
        <tr class="table-item">
          <td class="title" style="width:20%;">{{$t('mirroring.destination')}}</td>
          <td class="item" style="width:5%;" v-for="num in portNumber" :key="num">
            <radio :checked="tableRadioChecked(num)" @click.native="ontebleRadioSelection(num)" />
          </td>
        </tr>
      </table>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full footer-btn right" :title="$t('save')" @click="onSaveClick()" :disabled="!isButtonEnable">{{$t('save')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Radio from './module/Radio'
import toggle from './module/Toggle'
import labeling from './module/Labeling'
import checkbox from './module/Checkbox'
import machine from './module/Machine'
import { cloneDeep } from 'lodash'
import config from '../config'
import { mapActions, mapState, mapGetters } from 'vuex'
// import { number } from 'echarts/lib/export'
export default {
  name: 'Mirroring',
  components: {
    Radio,
    toggle,
    labeling,
    checkbox,
    machine
  },
  data () {
    return {
      isShowLoading: false,
      isMirroringEnable: false,
      isDisabled: false,
      isButtonEnable: false,
      typeRadioItems: ['txAndRx', 'txOnly', 'rxOnly'],
      desPort: 1,
      selectItem: [],
      selMode: 'txAndRx',
      ports: null,
      tabletitle: '',
      originalEnable: null,
      originalMode: 'txAndRx',
      originalData: null,
      sessionId: 1,
      updateInterval: null,
      portStatusList: null
    }
  },
  created: async function () {
    this.getData()
  },
  beforeDestroy: function () {
    clearInterval(this.updateInterval)
    this.updateInterval = null
  },
  watch: {
    isButtonEnable: function (value) {
      this.$store.commit('updateDataChanged', value)
    }
  },
  methods: {
    ...mapActions(['getMirroring', 'setMirroring', 'getPortStatus', 'getPortConfigure']),
    getData: function () {
      this.isShowLoading = true
      this.isButtonEnable = false
      this.selectItem = []
      this.getMirroring()
        .then((res) => {
          if (res.error_code === 200 && res.result) {
            let mode = false
            res.result.forEach(element => {
              if (element.val.Mode) {
                mode = true
                this.sessionId = element.key
                let tempList = element.val.DestinationPortList
                let rxList = element.val.SourcePortListRx
                let txList = element.val.SourcePortListTx
                if (tempList.indexOf('Gi 1/17') < 0 || tempList.indexOf('Gi 1/18') < 0) {
                  this.desPort = parseInt(tempList[0])
                  if (rxList.length > 0 && txList.length > 0) {
                    this.selMode = 'txAndRx'
                    this.originalMode = 'txAndRx'
                    txList.forEach(element => {
                      this.selectItem.push(parseInt(element))
                    })
                  } else if (rxList.length > 0 && txList.length === 0) {
                    this.selMode = 'rxOnly'
                    this.originalMode = 'rxOnly'
                    rxList.forEach(element => {
                      this.selectItem.push(parseInt(element))
                    })
                  } else if (rxList.length === 0 && txList.length > 0) {
                    this.selMode = 'txOnly'
                    this.originalMode = 'txOnly'
                    txList.forEach(element => {
                      this.selectItem.push(parseInt(element))
                    })
                  }
                }
              }
            })
            if (mode) {
              this.isMirroringEnable = true
              this.isDisabled = false
              this.originalEnable = true
            } else {
              this.isMirroringEnable = false
              this.isDisabled = true
              this.originalEnable = false
            }
            this.isShowLoading = false
            this.setOriginalData()
          }
        })
      if (!this.updateInterval) {
        let me = this
        this.updateInterval = setInterval(() => {
          try {
            if (!this.deviceCollapsed) {
              let tempArray = null
              tempArray = cloneDeep(me.portStatus)
              me.portStatusList = tempArray
              me.setSourceColor()
              me.setDesColor(me.desPort)
            }
          } catch (err) {
            this.$log.error(err)
          }
        }, this.intervalTime)
      }
    },
    setOriginalData: function () {
      this.originalData = {
        'Mode': this.isMirroringEnable,
        'Type': this.selMode,
        'List': cloneDeep(this.selectItem),
        'Destination': this.desPort
      }
    },
    setSourceColor: function () {
      let tempList = []
      for (var index = 1; index <= this.portNumber; index++) {
        tempList.push(index)
      }
      this.selectItem.forEach((item) => {
        let imgItem = document.getElementById('ethernet_' + (item))
        let sfpItem = (this.portStatusList[item - 1].val.Combo || this.onlySFPlist.indexOf(item) > -1) ? document.getElementById('sfp_' + item) : null
        let backgroundImg = this.$getElementsByClassName((!sfpItem) ? imgItem : sfpItem, 'circle')[0]
        if (imgItem) {
          backgroundImg = this.$getElementsByClassName(imgItem, 'circle')[0]
          backgroundImg.style.fill = '#4AD2E2'
        }
        if (sfpItem) {
          backgroundImg = this.$getElementsByClassName(sfpItem, 'circle')[0]
          backgroundImg.style.fill = '#4AD2E2'
        }
        tempList.splice(tempList.indexOf(item), 1)
      })
      tempList.forEach((item) => {
        if (item !== this.desPort) {
          let imgItem = document.getElementById('ethernet_' + (item))
          let sfpItem = (this.portStatusList[item - 1].val.Combo || this.onlySFPlist.indexOf(item) > -1) ? document.getElementById('sfp_' + item) : null
          let backgroundImg = this.$getElementsByClassName((!sfpItem) ? imgItem : sfpItem, 'circle')[0]
          if (imgItem) {
            backgroundImg = this.$getElementsByClassName(imgItem, 'circle')[0]
            backgroundImg.style.fill = '#3B415F'
          }
          if (sfpItem) {
            backgroundImg = this.$getElementsByClassName(sfpItem, 'circle')[0]
            backgroundImg.style.fill = '#3B415F'
          }
        }
      })
    },
    setDesColor: function (oldValue, newValue) {
      let imgItem = null
      let sfpItem = null
      let backgroundImg = null
      if (oldValue && newValue) {
        imgItem = document.getElementById('ethernet_' + (newValue))
        sfpItem = (this.portStatusList[newValue - 1].val.Combo || this.onlySFPlist.indexOf(newValue) > -1) ? document.getElementById('sfp_' + newValue) : null
        backgroundImg = this.$getElementsByClassName((!sfpItem) ? imgItem : sfpItem, 'circle')[0]
        if (imgItem) {
          backgroundImg = this.$getElementsByClassName(imgItem, 'circle')[0]
          backgroundImg.style.fill = '#BD10E0'
        }
        if (sfpItem) {
          backgroundImg = this.$getElementsByClassName(sfpItem, 'circle')[0]
          backgroundImg.style.fill = '#BD10E0'
        }
        imgItem = document.getElementById('ethernet_' + (oldValue))
        sfpItem = (this.portStatusList[oldValue - 1].val.Combo || this.onlySFPlist.indexOf(oldValue) > -1) ? document.getElementById('sfp_' + oldValue) : null
        backgroundImg = this.$getElementsByClassName((!sfpItem) ? imgItem : sfpItem, 'circle')[0]
        if (imgItem) {
          backgroundImg = this.$getElementsByClassName(imgItem, 'circle')[0]
          backgroundImg.style.fill = '#3B415F'
        }
        if (sfpItem) {
          backgroundImg = this.$getElementsByClassName(sfpItem, 'circle')[0]
          backgroundImg.style.fill = '#3B415F'
        }
      } else if (oldValue && !newValue) {
        imgItem = document.getElementById('ethernet_' + (this.desPort))
        sfpItem = (this.portStatusList[this.desPort - 1].val.Combo || this.onlySFPlist.indexOf(this.desPort) > -1) ? document.getElementById('sfp_' + this.desPort) : null
        backgroundImg = this.$getElementsByClassName((!sfpItem) ? imgItem : sfpItem, 'circle')[0]
        if (imgItem) {
          backgroundImg = this.$getElementsByClassName(imgItem, 'circle')[0]
          backgroundImg.style.fill = '#BD10E0'
        }
        if (sfpItem) {
          backgroundImg = this.$getElementsByClassName(sfpItem, 'circle')[0]
          backgroundImg.style.fill = '#BD10E0'
        }
      }
    },
    onSwitchBtn: function () {
      this.isMirroringEnable = !this.isMirroringEnable
      this.isDisabled = !this.isDisabled
      this.isButtonEnable = true
    },
    isItemChecked: function (item) {
      return (item === this.selMode)
    },
    onSelection: function (item) {
      this.selMode = item
      this.isButtonEnable = true
    },
    ontableSelection: function (item) {
      let index = this.selectItem.indexOf(item)
      if (this.desPort !== item) {
        if (index > -1) {
          this.selectItem.splice(index, 1)
        } else {
          this.selectItem.push(item)
        }
      }
      if (this.selectItem.length > 2) this.selectItem.splice(0, 1)
      if (!this.deviceCollapsed) this.setSourceColor()
      this.isButtonEnable = true
    },
    istableItemChecked: function (item) {
      let index = this.selectItem.indexOf(item)
      return (index > -1)
    },
    tableRadioChecked: function (item) {
      return (this.desPort === item)
    },
    ontebleRadioSelection: function (item) {
      let index = this.selectItem.indexOf(item)
      if (!this.deviceCollapsed) this.setDesColor(this.desPort, item)
      this.desPort = item
      if (index > -1) {
        this.selectItem.splice(index, 1)
      }
      if (!this.deviceCollapsed) this.setSourceColor()
      this.isButtonEnable = true
    },
    getDisable: function (item) {
      return (this.desPort === item)
    },
    onSaveClick: function () {
      let tempData = {
        'Mode': this.isMirroringEnable,
        'Type': this.selMode,
        'List': this.selectItem,
        'Destination': this.desPort
      }
      if (!this.$compareObj(tempData, this.originalData)) {
        this.isShowLoading = true
        if (!this.isMirroringEnable) {
          for (var number = 1; number < this.portNumber; number++) {
            this.setMirroring({
              'key': number,
              'val': {
                'Mode': false
              }
            }).then((res) => {
              if (res.error) {
                if (res.error.code !== -32603) {
                  this.$log.debug(res.error.message)
                }
              } else {
                this.getData()
              }
            })
          }
        } else {
          let tempList = []
          this.selectItem.forEach(element => {
            tempList.push('' + element)
          })
          switch (this.selMode) {
            case 'txAndRx':
              this.setMirroring({
                'key': this.sessionId,
                'val': {
                  'Mode': this.isMirroringEnable,
                  'SourcePortListRx': tempList,
                  'SourcePortListTx': tempList,
                  'DestinationPortList': ['' + this.desPort]
                  // 'Type': 'mirror',
                  // 'RMirrorVlan': 200,
                  // 'ReflectorPort': this.model === '1',
                  // 'StripInnerTag': false,
                  // 'SourceVlans': [],
                  // 'CpuRx': false,
                  // 'CpuTx': false
                }
              }).then((res) => {
                if (res.error) {
                  if (res.error.code !== -32603) {
                    this.$log.debug(res.error.message)
                  }
                } else {
                  this.getData()
                }
              })
              break
            case 'rxOnly':
              this.setMirroring({
                'key': this.sessionId,
                'val': {
                  'Mode': this.isMirroringEnable,
                  'SourcePortListRx': tempList,
                  'SourcePortListTx': [],
                  'DestinationPortList': ['' + this.desPort]
                  // 'Type': 'mirror',
                  // 'RMirrorVlan': 200,
                  // 'ReflectorPort': '1',
                  // 'StripInnerTag': false,
                  // 'SourceVlans': [],
                  // 'CpuRx': false,
                  // 'CpuTx': false
                }
              }).then((res) => {
                if (res.error) {
                  if (res.error.code !== -32603) {
                    this.$log.debug(res.error.message)
                  }
                } else {
                  this.getData()
                }
              })
              break
            case 'txOnly':
              this.setMirroring({
                'key': this.sessionId,
                'val': {
                  'Mode': this.isMirroringEnable,
                  'SourcePortListRx': [],
                  'SourcePortListTx': tempList,
                  'DestinationPortList': ['' + this.desPort]
                  // 'Type': 'mirror',
                  // 'RMirrorVlan': 200,
                  // 'ReflectorPort': '1',
                  // 'StripInnerTag': false,
                  // 'SourceVlans': [],
                  // 'CpuRx': false,
                  // 'CpuTx': false
                }
              }).then((res) => {
                if (res.error) {
                  if (res.error.code !== -32603) {
                    this.$log.debug(res.error.message)
                  }
                } else {
                  this.getData()
                }
              })
              break
          }
        }
      }
    }
  },
  computed: {
    onlySFPlist: function () {
      return config.productDiff[this.systemHostInfo.Product].sfpPort
    },
    ...mapState({
      isDataChanged: state => state.app.isDataChanged,
      intervalTime: state => state.app.intervalTime,
      systemHostInfo: state => state.module.systemHostInfo,
      portNumber: state => state.module.portNum,
      deviceCollapsed: state => state.app.deviceCollapsed,
      portStatus: state => state.module.portStatus
    }),
    ...mapGetters(['getSwVersion'])
  }
}
</script>

<style lang="scss" scoped>
/deep/ svg.qsw-2108-2c, svg.qsw-2108-2s, svg.qsw-120x, svg.qsw-408, svg.qsw-1200-8c, svg.qsw-804, svg.qsw-5216-1t{
  width: auto;
  height:110px;
  .st2 {
    font-size: 4px;
  }
  .st3 {
    font-size: 6px;
  }
  .st4 {
    font-size: 8px;
  }
}
.mirroring {
  position: relative;
  .content-body {
    padding-top: 20px;
    .describe {
      color: #000;
      margin: 0px 20px 20px 20px;
    }
    .group-table {
      width: -webkit-fill-available;
      margin-top: 10px;
      margin-right: 10px;
      margin-left: 10px;
      color:black;
      td {
        height: 28px;
      }
      .title {
        padding-left: 20px;
        position: relative;
        .subtitle, .slash {
          color: #8C99FF;
        }
        .subtitle {
          position: absolute;
          display: inline-block;
          right: 10px;
          top: 0px;
        }
        .slash {
          position: absolute;
          display: inline-block;
          width: 100%;
          height: 28px;
          top: 0;
          left: 0;
          &:before {
            content: attr(data-text);
            position:absolute;
            left:0px;
            top:0;
            right:0;
            bottom:0;
            -webkit-clip-path: polygon(0 0, 0 100%, 230% 225%, 0 0);
            clip-path: polygon(0 0, 0 100%, 230% 225%, 0 0);
            background:#fff;
          }
        }
      }
      .all, .item {
        text-align: center;
      }
      .q-checkbox-label {
        display: block;
        margin: auto;
      }
      >.table-header {
        background-color: #F2F3F8;
        height: 27px;
      }
      >.table-item {
        height: 38px;
      }
      tr {
        border-bottom: 1px solid #F1F1F1;
      }
    }
    .formRow {
      color: #000;
      margin: 0px 20px 12px 20px;
      &.device {
        display: flex;
        margin: 0px 20px 12px 0px;
        .device-img {
          margin-left: 20%;
          margin-right: 10%;
          width: auto;
        }
      }
      &.mode {
        margin-left: 40px;
        >.title {
          display: inline-block;
        }
        >.q-radio {
          margin-right: 20px;
        }
      }
    }
    .labeling_group {
      margin: 0;
      margin-top: 20px;
      .label_link {
        .link_icon {
          background: #4AD2E2;
        }
      }
      .label_nolink {
        .nolink_icon {
          background: #BD10E0;
        }
      }
    }
  }
}
  .content-body-footer {
    position: absolute;
    top: calc(100% - 50px) !important;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Mirroring.vue